import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'yearMonthFormat',
})
export class YearMonthFormatPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        value = value.replace(/\D/, '')
        return value.substr(0, 4) + args + value.substr(4, 2)
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/year-month-format.pipe.ts